exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heroicon-contacts-book .heroicon-outline{fill:#303034}.heroicon-contacts-book .heroicon-component-fill{fill:#f7f7f8}.heroicon-contacts-book .heroicon-component-accent{fill:#8b9397}.heroicon-contacts-book .heroicon-shadows{fill:#303034;opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-617b90d0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icons/ContactsIcon.vue
// module id = tZ3S
// module chunks = 0